(function () {
  'use strict';
  // Both sections load this asset; install listeners only once.
  if (window.jdd_FloralQuoteLanding) { window.jdd_FloralQuoteLanding.init(document); return; }
  var maxAge = 60 * 60 * 1000;
  function read(key) {
    try { return JSON.parse(sessionStorage.getItem(key)); } catch (e) { return null; }
  }
  function write(key, value) {
    try { sessionStorage.setItem(key, JSON.stringify(value)); return true; } catch (e) { return false; }
  }
  function remove(key) { try { sessionStorage.removeItem(key); } catch (e) {} }
  function eventId() {
    return 'jdd_floral-quote-' + (window.crypto && crypto.randomUUID ? crypto.randomUUID() : Date.now() + '-' + Math.random().toString(36).slice(2));
  }
  function initPhone(form) {
    var input = form && form.querySelector('[data-jdd_us-phone]');
    if (!input) return;
    function digits(value) {
      var number = value.replace(/\D/g, '');
      if (/^\s*\+1/.test(value) || (number.length > 10 && number[0] === '1')) number = number.slice(1);
      return number.slice(0, 10);
    }
    function format(number) {
      if (!number) return '';
      return '+1 (' + number.slice(0, 3) + (number.length >= 3 ? ') ' : '') +
        number.slice(3, 6) + (number.length >= 6 ? '-' : '') + number.slice(6);
    }
    function caretFor(value, count) {
      if (count >= digits(value).length) return value.length;
      var seen = 0;
      for (var i = 4; i < value.length; i++) {
        if (/\d/.test(value[i]) && ++seen === count) return i + 1;
      }
      return 4;
    }
    function normalize() {
      var position = input.selectionStart;
      var count = digits(input.value.slice(0, position == null ? input.value.length : position)).length;
      input.value = format(digits(input.value));
      if (document.activeElement === input) {
        var caret = caretFor(input.value, count);
        input.setSelectionRange(caret, caret);
      }
    }
    input.addEventListener('input', normalize);
    input.addEventListener('change', normalize);
    // Delete digits rather than getting stuck on parentheses or the hyphen.
    input.addEventListener('beforeinput', function (event) {
      if (input.selectionStart !== input.selectionEnd ||
          (event.inputType !== 'deleteContentBackward' && event.inputType !== 'deleteContentForward')) return;
      var backward = event.inputType === 'deleteContentBackward';
      var positions = [];
      for (var i = 4; i < input.value.length; i++) if (/\d/.test(input.value[i])) positions.push(i);
      var index = backward ? -1 : positions.length;
      positions.forEach(function (position, digitIndex) {
        if (backward && position < input.selectionStart) index = digitIndex;
        if (!backward && position >= input.selectionStart && index === positions.length) index = digitIndex;
      });
      event.preventDefault();
      if (index < 0 || index >= positions.length) return;
      var number = digits(input.value);
      input.value = format(number.slice(0, index) + number.slice(index + 1));
      var caret = index === 0 ? Math.min(4, input.value.length) : caretFor(input.value, index);
      input.setSelectionRange(caret, caret);
    });
    normalize();
  }
  function loadVideo(video) {
    if (video.dataset.jdd_videoLoaded) return true;
    var sources = Array.prototype.slice.call(video.querySelectorAll('[data-jdd_video-source]'));
    var hls = sources.find(function (source) { return /mpegurl/i.test(source.type); });
    var selected;
    if (hls && video.canPlayType(hls.type)) selected = hls;
    else {
      var mp4 = sources.filter(function (source) { return source.type === 'video/mp4'; });
      mp4.sort(function (a, b) { return Number(a.dataset.jdd_width) - Number(b.dataset.jdd_width); });
      var limit = video.classList.contains('jdd_floral-quote__background-video') ? 1600 : 720;
      var target = Math.min(limit, Math.max(320, video.clientWidth * Math.min(window.devicePixelRatio || 1, 2)));
      selected = mp4.find(function (source) { return Number(source.dataset.jdd_width) >= target; }) || mp4[mp4.length - 1];
    }
    if (!selected) return false;
    video.src = selected.dataset.jdd_src;
    video.dataset.jdd_videoLoaded = 'true';
    video.load();
    return true;
  }
  function readPixelConfig(script) {
    var match = /\bwebPixelsConfigList\s*:\s*\[/.exec(script);
    if (!match) return null;
    var start = script.indexOf('[', match.index);
    var depth = 0;
    var quoted = false;
    var escaped = false;
    // Parse only the JSON array in Shopify's bootstrap. Never execute page scripts.
    for (var i = start; i < script.length; i++) {
      var character = script[i];
      if (quoted) {
        if (escaped) escaped = false;
        else if (character === '\\') escaped = true;
        else if (character === '"') quoted = false;
      } else if (character === '"') quoted = true;
      else if (character === '[') depth++;
      else if (character === ']' && --depth === 0) {
        try { return JSON.parse(script.slice(start, i + 1)); } catch (e) { return null; }
      }
    }
    return null;
  }
  function connectedMetaPixel() {
    var candidates = [];
    document.querySelectorAll('script:not([src])').forEach(function (script) {
      var list = readPixelConfig(script.textContent || '');
      if (!Array.isArray(list)) return;
      list.forEach(function (pixel) {
        if (pixel.type !== 'APP' || String(pixel.apiClientId) !== '2329312' || pixel.runtimeContext !== 'OPEN') return;
        try {
          var config = typeof pixel.configuration === 'string' ? JSON.parse(pixel.configuration) : pixel.configuration;
          var id = config && String(config.pixel_id || '');
          if (config && config.pixel_type === 'facebook_pixel' && /^\d+$/.test(id) && candidates.indexOf(id) < 0) candidates.push(id);
        } catch (e) {}
      });
    });
    // Do not guess if there is no connected OPEN Meta pixel or more than one.
    return candidates.length === 1 ? candidates[0] : null;
  }
  function appPixelReady(pixelId) {
    if (!pixelId || typeof window.fbq !== 'function') return false;
    try {
      if (typeof fbq.getState === 'function') {
        var state = fbq.getState();
        if (state && Array.isArray(state.pixels) && state.pixels.some(function (pixel) { return String(pixel.id) === pixelId; })) return true;
      }
      return !!(fbq.queue && Array.prototype.some.call(fbq.queue, function (args) { return args[0] === 'init' && String(args[1]) === pixelId; }));
    } catch (e) { return false; }
  }
  function advertisingAllowed() {
    var privacy = window.Shopify && Shopify.customerPrivacy;
    return !!(privacy && typeof privacy.marketingAllowed === 'function' && privacy.marketingAllowed() &&
      typeof privacy.analyticsProcessingAllowed === 'function' && privacy.analyticsProcessingAllowed() &&
      typeof privacy.saleOfDataAllowed === 'function' && privacy.saleOfDataAllowed());
  }
  function loadPrivacy(callback) {
    if (window.Shopify && Shopify.customerPrivacy) { callback(); return; }
    if (window.Shopify && typeof Shopify.loadFeatures === 'function') {
      Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], function (error) { if (!error) callback(); });
    }
  }
  function initQuote(root) {
    if (root.dataset.jdd_initialized) return;
    root.dataset.jdd_initialized = 'true';
    var form = root.querySelector('form');
    initPhone(form);
    var result = root.querySelector('[data-jdd_quote-result]');
    var key = 'jdd_floral-quote:pending:' + location.pathname + ':' + root.dataset.jdd_sectionId;
    var testMode = root.dataset.jdd_testMode === 'true';
    var card = root.querySelector('.jdd_floral-quote__card');
    var cardSlot = root.querySelector('.jdd_floral-quote__card-slot');
    function quoteLayout() {
      if (!card) return null;
      return { width: window.innerWidth, height: card.getBoundingClientRect().height, scrollY: window.scrollY || 0 };
    }
    function keepCardSpace(layout) {
      if (cardSlot && layout && layout.width === window.innerWidth && layout.height > 0) {
        // Reserve transparent space, while the visible card fits its message.
        cardSlot.style.minHeight = layout.height + 'px';
      }
    }
    function restoreQuoteLayout(layout) {
      if (!layout || layout.width !== window.innerWidth) return;
      keepCardSpace(layout);
      // The native Shopify redirect reloads the page; restore its prior position.
      // Stop restoring if the visitor starts scrolling before assets finish loading.
      var interrupted = false;
      function interrupt() { interrupted = true; }
      function restore() {
        if (!interrupted) window.scrollTo({ top: layout.scrollY, left: 0, behavior: 'instant' });
      }
      function cleanup() {
        window.removeEventListener('wheel', interrupt);
        window.removeEventListener('touchstart', interrupt);
        window.removeEventListener('keydown', interrupt);
      }
      window.addEventListener('wheel', interrupt, { passive: true });
      window.addEventListener('touchstart', interrupt, { passive: true });
      window.addEventListener('keydown', interrupt);
      requestAnimationFrame(restore);
      if (document.readyState === 'complete') cleanup();
      else window.addEventListener('load', function () { restore(); cleanup(); }, { once: true });
    }
    if (form && !testMode) form.addEventListener('submit', function () {
      // Native Shopify POST and its captcha flow remain in charge of delivery.
      if (form.checkValidity()) write(key, { id: eventId(), time: Date.now(), path: location.pathname, layout: quoteLayout() });
    });
    var submittedQuote = read(key);
    if (result && result.dataset.jdd_errors === 'true') remove(key);
    var success = result && result.dataset.jdd_success === 'true';
    if (result && (success || result.dataset.jdd_errors === 'true') && submittedQuote && submittedQuote.path === location.pathname && Date.now() - submittedQuote.time < maxAge) {
      restoreQuoteLayout(submittedQuote.layout);
    }
    if (success) {
      var message = root.querySelector('.jdd_floral-quote__success');
      if (message) message.focus({ preventScroll: true });
    }
    function publishLead(pending) {
      if (root.dataset.jdd_trackLead !== 'true' || (window.Shopify && Shopify.designMode)) return;
      if (pending && pending.path === location.pathname && Date.now() - pending.time < maxAge) {
        var firedKey = 'jdd_floral-quote:fired:' + pending.id;
        var sent = !!read(firedKey);
        var timer;
        var attempts = 0;
        function stop() { clearInterval(timer); document.removeEventListener('visitorConsentCollected', resumeLead); }
        function sendLead() {
          if (sent || read(firedKey)) { stop(); return; }
          if (Date.now() - pending.time >= maxAge || !document.documentElement.contains(root)) { stop(); return; }
          var pixelId = connectedMetaPixel();
          if (!appPixelReady(pixelId) || !advertisingAllowed()) return;
          try {
            // Reuse the app's initialized pixel. No init, SDK injection or PageView.
            fbq('trackSingle', pixelId, 'Lead', {
              content_name: 'Get a Quote',
              content_category: 'Floral N5'
            }, { eventID: pending.id });
            sent = true;
            write(firedKey, { time: Date.now() });
            remove(key);
            stop();
          } catch (e) { /* Analytics never prevents the contact form from working. */ }
        }
        function resumeLead() {
          clearInterval(timer);
          sendLead();
          if (sent || read(firedKey) || Date.now() - pending.time >= maxAge) return;
          attempts = 0;
          timer = setInterval(function () {
            sendLead();
            if (++attempts >= 60) {
              clearInterval(timer);
              if (!sent && window.console) console.warn('Floral N5: Lead is waiting for the app pixel or advertising consent.');
            }
          }, 500);
        }
        document.addEventListener('visitorConsentCollected', resumeLead);
        loadPrivacy(resumeLead);
        resumeLead();
      }
    }
    // Production: require a successful Shopify response and a recent submission.
    if (success && !testMode) publishLead(read(key));
    if (form && testMode) {
      remove(key);
      var testSubmitted = false;
      function submitTest(event) {
        event.preventDefault();
        if (testSubmitted || !form.reportValidity()) return;
        testSubmitted = true;
        // Local simulation only: no fetch, no POST and no contact endpoint.
        var pending = { id: eventId(), time: Date.now(), path: location.pathname };
        publishLead(pending);
        keepCardSpace(quoteLayout());
        form.hidden = true;
        var testSuccess = root.querySelector('[data-jdd_quote-test-success]');
        if (testSuccess) { testSuccess.hidden = false; testSuccess.focus({ preventScroll: true }); }
      }
      form.addEventListener('submit', submitTest);
      var testButton = root.querySelector('[data-jdd_quote-test-submit]');
      if (testButton) testButton.addEventListener('click', submitTest);
      form.addEventListener('keydown', function (event) {
        if (event.key === 'Enter' && event.target.tagName === 'INPUT') submitTest(event);
      });
    }
    var background = root.querySelector('.jdd_floral-quote__background-video');
    var toggle = root.querySelector('[data-jdd_background-toggle]');
    if (background && toggle) {
      var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      var connection = navigator.connection;
      var autoAllowed = !reducedMotion && !(connection && (connection.saveData || /(^|-)2g$/.test(connection.effectiveType)));
      var visible = true;
      var manuallyPaused = false;
      var ready = document.readyState === 'complete';
      var image = root.querySelector('.jdd_floral-quote__media img');
      var imageReady = !image || image.complete;
      var scheduled = false;
      var started = false;
      background.muted = true;
      background.defaultMuted = true;
      function syncToggle() {
        toggle.textContent = background.paused ? 'Play video' : 'Pause video';
        toggle.setAttribute('aria-label', background.paused ? 'Play background video' : 'Pause background video');
        toggle.setAttribute('aria-pressed', String(background.paused));
      }
      function playBackground() {
        if (!loadVideo(background)) return;
        started = true;
        var promise = background.play();
        if (promise) promise.catch(syncToggle);
      }
      function resume() {
        if (!autoAllowed || manuallyPaused || !visible || document.hidden || !ready || !imageReady || scheduled) return;
        if (started) { playBackground(); return; }
        scheduled = true;
        function start() {
          scheduled = false;
          if (visible && !document.hidden && !manuallyPaused) playBackground();
        }
        // Let the eagerly loaded hero photo paint before downloading video.
        if (window.requestIdleCallback) window.requestIdleCallback(start, { timeout: 2000 });
        else setTimeout(start, 600);
      }
      if (image && !imageReady) {
        ['load', 'error'].forEach(function (name) { image.addEventListener(name, function () { imageReady = true; resume(); }, { once: true }); });
      }
      if (!ready) window.addEventListener('load', function () { ready = true; resume(); }, { once: true });
      if (window.IntersectionObserver) {
        visible = false;
        var heroObserver = new IntersectionObserver(function (entries) {
          visible = entries[0].isIntersecting;
          if (!visible) background.pause();
          else resume();
        }, { threshold: 0.05 });
        heroObserver.observe(root);
      }
      document.addEventListener('visibilitychange', function () {
        if (document.hidden) background.pause();
        else resume();
      });
      if (reducedMotion) toggle.hidden = true;
      background.addEventListener('playing', function () { background.dataset.jdd_playing = 'true'; });
      background.addEventListener('play', syncToggle);
      background.addEventListener('pause', syncToggle);
      toggle.addEventListener('click', function () {
        if (background.paused) { manuallyPaused = false; playBackground(); }
        else { manuallyPaused = true; background.pause(); }
      });
      syncToggle();
      resume();
    }
  }
  function initGallery(root) {
    if (root.dataset.jdd_initialized) return;
    root.dataset.jdd_initialized = 'true';
    var track = root.querySelector('.jdd_floral-gallery__track');
    var previous = root.querySelector('[data-jdd_gallery-prev]');
    var next = root.querySelector('[data-jdd_gallery-next]');
    var arrows = root.querySelector('.jdd_floral-gallery__arrows');
    var videos = Array.prototype.slice.call(root.querySelectorAll('video'));
    function update() {
      var overflow = track.scrollWidth - track.clientWidth;
      arrows.hidden = overflow < 2;
      previous.disabled = track.scrollLeft < 2;
      next.disabled = track.scrollLeft >= overflow - 2;
    }
    function scroll(direction) {
      var item = track.querySelector('.jdd_floral-gallery__item');
      var gap = parseFloat(getComputedStyle(track).columnGap) || 0;
      track.scrollBy({ left: direction * ((item ? item.offsetWidth : track.clientWidth) + gap), behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
    }
    previous.addEventListener('click', function () { scroll(-1); });
    next.addEventListener('click', function () { scroll(1); });
    track.addEventListener('keydown', function (event) {
      if (event.target !== track || (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight')) return;
      event.preventDefault();
      scroll(event.key === 'ArrowLeft' ? -1 : 1);
    });
    track.addEventListener('scroll', update, { passive: true });
    if (window.ResizeObserver) { new ResizeObserver(update).observe(track); }
    else window.addEventListener('resize', update);
    videos.forEach(function (video) {
      var frame = video.closest('.jdd_floral-gallery__frame');
      var button = frame.querySelector('[data-jdd_video-play]');
      function showPlayer() { frame.dataset.jdd_playing = 'true'; video.tabIndex = 0; button.hidden = true; }
      video.addEventListener('playing', showPlayer);
      video.addEventListener('play', function () {
        document.querySelectorAll('[data-jdd_deferred-video]').forEach(function (other) { if (other !== video) other.pause(); });
      });
      button.addEventListener('click', function () {
        if (!loadVideo(video)) return;
        var promise = video.play();
        if (promise) promise.then(function () { showPlayer(); video.focus({ preventScroll: true }); }).catch(function () {
          frame.dataset.jdd_playing = 'false'; button.hidden = false;
          button.setAttribute('aria-label', 'Try playing this video again');
        });
      });
    });
    if (window.IntersectionObserver) {
      var observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) { if (!entry.isIntersecting) entry.target.pause(); });
      }, { threshold: 0.1 });
      videos.forEach(function (video) { observer.observe(video); });
    }
    document.addEventListener('visibilitychange', function () {
      if (document.hidden) videos.forEach(function (video) { video.pause(); });
    });
    update();
  }
  function init(scope) {
    scope.querySelectorAll('[data-jdd_floral-quote]').forEach(initQuote);
    scope.querySelectorAll('[data-jdd_floral-gallery]').forEach(initGallery);
  }
  window.jdd_FloralQuoteLanding = { init: init };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(document); });
  else init(document);
  document.addEventListener('shopify:section:load', function (event) { init(event.target); });
}());
